import {inject} from '@angular/core';
import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {throwError} from 'rxjs';
import {catchError, exhaustMap} from 'rxjs/operators';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {BasicAuthDialogComponent} from '~shared/ng/interceptors/dialog/basic-auth-dialog/basic-auth-dialog.component';

export const basicAuthInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    const dialog = inject(DialogService);

    return next(req).pipe(catchError((errorResponse: Readonly<HttpErrorResponse>) => {
        if (errorResponse.error &&
            typeof errorResponse.error === 'object' &&
            'errors' in errorResponse.error &&
            errorResponse.error?.errors[0]?.error === 'required' &&
            (errorResponse.error?.errors[0]?.error_param === 'basic_auth_email' || errorResponse.error?.errors[0]?.error_param === 'basic_auth_password')
        ) {
            return dialog.create(BasicAuthDialogComponent).onClose$
                .pipe(
                    exhaustMap(result => {
                        if (!result) {
                            return throwError(() => errorResponse);
                        }

                        const duplicate = req.clone({
                            body: {
                                ...req.body,
                                basicAuthEmail: result.basicAuthEmail,
                                basicAuthPassword: result.basicAuthPassword
                            }
                        });
                        return next(duplicate);
                    })
                );
        } else {
            return throwError(() => errorResponse);
        }
    }));
};
